import React from 'react';
import LeftPanel from '../../components/layouts/user/left-panel';
import RightPanel from '../../components/layouts/user/right-panel';
import TopNav from '../../components/layouts/user/topnav';
import { Layout } from 'antd';
import styles from './styles.module.scss';
import {
  UserProfileDataContext,
  UserDesignationDataContext,
  ProfilePictureContext,
} from '../../context';
import useGetProfileData from '../../hooks/GetProfileData';

const UserProfile: React.FC = (): JSX.Element => {
  const [
    userProfileData,
    setUserProfileData,
    userDesignationData,
    setUserDesignationData,
    userProfilePictureData,
    setUserProfilePictureData,
  ] = useGetProfileData();

  return (
    <>
      <UserProfileDataContext.Provider
        value={{ userProfileData, setUserProfileData }}
      >
        <UserDesignationDataContext.Provider
          value={{ userDesignationData, setUserDesignationData }}
        >
          <ProfilePictureContext.Provider
            value={{ userProfilePictureData, setUserProfilePictureData }}
          >
            <Layout className={styles.layout}>
              <TopNav {...{ type: 'user' }} />
              <Layout className={styles.layout}>
                <LeftPanel />
                <RightPanel />
              </Layout>
            </Layout>
          </ProfilePictureContext.Provider>
        </UserDesignationDataContext.Provider>
      </UserProfileDataContext.Provider>
    </>
  );
};

export default UserProfile;
